(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    class AdabSizeGuide extends HTMLElement {
    connectedCallback() {
      this.#abortController = new AbortController();
      this.#bindUnitControls();
      this.#bindComponentTabs();
      this.#syncVariant();

      document.addEventListener('variant:selected', this.#syncVariant, {
        signal: this.#abortController.signal,
      });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #abortController;

    #bindUnitControls() {
      this.querySelectorAll('[data-unit]').forEach((button) => {
        button.addEventListener('click', () => {
          const unit = button.dataset.unit;
          this.dataset.unit = unit;
          this.querySelectorAll('[data-unit]').forEach((control) => {
            control.setAttribute('aria-pressed', String(control === button));
          });
          this.querySelectorAll('[data-unit-value]').forEach((value) => {
            value.hidden = value.dataset.unitValue !== unit;
          });
          const status = this.querySelector('[data-unit-status]');
          if (status) status.textContent = unit.toUpperCase();
        }, { signal: this.#abortController.signal });
      });
    }

    #bindComponentTabs() {
      this.querySelectorAll('[data-component-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const componentId = tab.dataset.componentTab;
          this.querySelectorAll('[data-component-tab]').forEach((control) => {
            control.setAttribute('aria-selected', String(control === tab));
            control.setAttribute('tabindex', control === tab ? '0' : '-1');
          });
          this.querySelectorAll('[data-component-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.componentPanel !== componentId;
          });
        }, { signal: this.#abortController.signal });

        tab.addEventListener('keydown', (event) => {
          const tabs = Array.from(this.querySelectorAll('[data-component-tab]'));
          const currentIndex = tabs.indexOf(tab);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === currentIndex) return;

          event.preventDefault();
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        }, { signal: this.#abortController.signal });
      });
    }

    #syncVariant = () => {
      const picker = document.querySelector('variant-picker');
      const controls = picker?.querySelectorAll('fieldset, select') ?? [];
      let selectedSize = '';

      controls.forEach((control) => {
        const label = control instanceof HTMLFieldSetElement
          ? control.querySelector('legend')?.textContent?.toLowerCase() ?? ''
          : Array.from(picker.querySelectorAll('label')).find((item) => item.htmlFor === control.id)?.textContent?.toLowerCase() ?? '';
        if (!label.includes('size')) return;

        const selectedInput = control.querySelector?.('input:checked');
        const selectedOption = control instanceof HTMLSelectElement ? control.options[control.selectedIndex] : null;
        selectedSize = selectedInput?.value ?? selectedOption?.value ?? '';
      });

      if (!selectedSize) return;

      this.querySelectorAll('[data-size-row]').forEach((row) => {
        const isSelected = row.dataset.size?.toLowerCase() === selectedSize.toLowerCase();
        if (isSelected) {
          row.setAttribute('data-selected', 'true');
        } else {
          row.removeAttribute('data-selected');
        }
        row.setAttribute('aria-selected', String(isSelected));
      });
    };
  }

  if (!customElements.get('adab-size-guide')) {
    customElements.define('adab-size-guide', AdabSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
